import { cloneElement } from 'react';
import { Label } from './ui/label';

/**
 * Renders a labeled control with its react-hook-form error message.
 * The child input is given `id` matching the label's `htmlFor`.
 */
export default function Field({ name, label, error, children }) {
  return (
    <div className="space-y-2">
      <Label htmlFor={name}>{label}</Label>
      {cloneElement(children, { id: name })}
      {error && <p className="text-sm text-destructive">{error}</p>}
    </div>
  );
}
